import React from 'react'
import { Link } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import { useIsMobile } from 'lib/hooks'

const PaymentsUnavailableWarning = ({ lessonTypeId }) => {
  const isMobile = useIsMobile()
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      style={{
        borderRadius: '8px',
        backgroundColor: '#feecea',
        padding: '1rem',
      }}
      mb={3}
    >
      <Box display="flex" alignItems="center" width="60%">
        <Typography variant="body2" gutterBottom color="textPrimary">
          <strong>Payments unavailable.</strong> Your payment account needs
          attention before you can collect payments. Update your{' '}
          <Link
            to={`/pga-coach/bookings/booking-types/edit/${lessonTypeId}#payment-options`}
          >
            payment settings
          </Link>{' '}
          to continue.
        </Typography>
      </Box>
      <Box color="textSecondary">
        <Button
          color="primary"
          variant="outlined"
          disabled
          size={isMobile ? 'small' : 'medium'}
        >
          Collect Payment
        </Button>
      </Box>
    </Box>
  )
}

export default PaymentsUnavailableWarning
